export default class Action {

  constructor ({title, icon} = {}) {
    this._title = title;
    this._icon = icon;
  }

  _executeSync () {
  }

  execute () {
    try {
      this._executeSync();
      return Promise.resolve();
    } catch (error) {
      return Promise.reject(error);
    }
  }

  get title () {
    return this._title;
  }

  get icon () {
    return this._icon;
  }

  _isSupportedSync () {
    return false;
  }

  isSupported () {
    return this._isSupportedSync() ? Promise.resolve() : Promise.reject();
  }

}
